/**
 * Події історії заявки (`/services/transport-requests/{uuid}/history`), які пише
 * бекендний `TransportRequestHistoryService::record`. Кольори — hex для Ship StatusBadge.
 */
export type HistoryEvent =
    | 'status_changed'
    | 'executor_block_status_changed'
    | 'dispatcher_assigned'
    | 'delegated'
    | 'cancelled'
    | 'updated'
    | 'created'

export const HISTORY_EVENT_MAP: Record<HistoryEvent, { label: string; color: string }> = {
    status_changed: { label: 'Статус змінено', color: '#1890ff' },
    executor_block_status_changed: { label: 'Статус виконавця', color: '#13c2c2' },
    dispatcher_assigned: { label: 'Диспетчер призначений', color: '#52c41a' },
    delegated: { label: 'Делеговано', color: '#faad14' },
    cancelled: { label: 'Скасовано', color: '#ff4d4f' },
    updated: { label: 'Оновлено', color: '#8c8c8c' },
    created: { label: 'Створено', color: '#722ed1' },
}
